var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "button",
    {
      staticClass: "square-button",
      on: {
        click: function click($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("studip-icon", {
        attrs: {
          shape: _vm.icon,
          size: 50,
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.title))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }